import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { MESSAGE_STREAMING_REPOSITORY } from '../../core';
import { MESSAGE_STREAMING_API } from '../data-sources';
export var MessageStreamingWebRepository = /*#__PURE__*/function () {
  function MessageStreamingWebRepository(messageStreamingApi) {
    _classCallCheck(this, MessageStreamingWebRepository);

    this.messageStreamingApi = messageStreamingApi;
  }

  _createClass(MessageStreamingWebRepository, [{
    key: "subscribeToConversation",
    value: function subscribeToConversation(conversationId, callbacks) {
      var unsubscribeFn = this.messageStreamingApi.subscribeToConversation(conversationId, callbacks);
      return {
        unsubscribe: unsubscribeFn
      };
    }
  }]);

  return MessageStreamingWebRepository;
}();
export var messageStreamingWebRepositoryProvider = {
  provide: MESSAGE_STREAMING_REPOSITORY,
  useFactory: function useFactory(messageStreamingApi) {
    return new MessageStreamingWebRepository(messageStreamingApi);
  },
  inject: [MESSAGE_STREAMING_API]
};